// src/layouts/contact/index.jsx

import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import GradientBorder from "examples/GradientBorder";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import Footer from "examples/Footer";

import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import radialGradient from "assets/theme/functions/radialGradient";

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validação simples no frontend
    if (!formData.name || !formData.email || !formData.message) {
      setStatusMsg("Por favor, preencha todos os campos.");
      return;
    }

    setIsSubmitting(true);
    setStatusMsg("");

    try {
      const response = await fetch("https://www.perfectoespanhol.com.br/api/formulario-portfolio.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setStatusMsg(result.mensagem || result.erro);

      if (result.mensagem) {
        setFormData({ name: "", email: "", message: "" });
      }
    } catch (error) {
      console.error(error);
      setStatusMsg("Erro ao enviar o formulário. Tente novamente mais tarde.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DefaultNavbar />
      <VuiBox py={3}>
        <Card>
          <CardContent>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} md={8}>
                <VuiBox textAlign="center" px={2}>
                  <VuiTypography variant="button" color="success" fontWeight="bold" mb={1}>
                    Vamos conversar?
                  </VuiTypography>
                  <VuiTypography variant="h2" color="white" fontWeight="bold" mb={2}>
                    Envie sua mensagem
                  </VuiTypography>
                  <VuiTypography variant="body2" color="text" maxWidth="600px" mx="auto">
                    Preencha o formulário abaixo e entrarei em contato o mais breve possível.
                  </VuiTypography>
                </VuiBox>
              </Grid>
            </Grid>

            <VuiBox
              component="form"
              onSubmit={handleSubmit}
              maxWidth="530px"
              mx="auto"
              mt={5}
              display="flex"
              flexDirection="column"
              gap={3}
            >
              {[
                { label: "Nome", name: "name", placeholder: "Seu nome completo" },
                { label: "Email", name: "email", placeholder: "Seu melhor e-mail" },
                {
                  label: "Mensagem",
                  name: "message",
                  placeholder: "Digite sua mensagem aqui",
                  multiline: true,
                },
              ].map(({ label, name, placeholder, multiline }) => (
                <VuiBox key={name}>
                  <VuiTypography
                    component="label"
                    variant="button"
                    color="white"
                    fontWeight="medium"
                    mb={1}
                  >
                    {label}
                  </VuiTypography>
                  <GradientBorder
                    minWidth="100%"
                    borderRadius={borders.borderRadius.lg}
                    padding="1px"
                    backgroundImage={radialGradient(
                      palette.gradients.borderLight.main,
                      palette.gradients.borderLight.state,
                      palette.gradients.borderLight.angle
                    )}
                  >
                    <VuiInput
                      name={name}
                      placeholder={placeholder}
                      value={formData[name]}
                      onChange={handleChange}
                      multiline={multiline || false}
                      rows={multiline ? 4 : 1}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "#fff",
                          "&::placeholder": {
                            color: "#aaa !important", // cor com !important aplicado
                            opacity: "1 !important",
                          },
                        },
                      }}                      
                    />
                  </GradientBorder>
                </VuiBox>
              ))}

              <VuiButton
                type="submit"
                color="info"
                disabled={isSubmitting}
                sx={{
                  width: "fit-content",
                  px: 4,
                  mx: "auto",
                }}
              >
                {isSubmitting ? "Enviando..." : "ENVIAR MENSAGEM"}
              </VuiButton>

              {statusMsg && (
                <VuiTypography
                  mt={2}
                  color={statusMsg.includes("sucesso") ? "success" : "error"}
                  textAlign="center"
                >
                  {statusMsg}
                </VuiTypography>
              )}

              {statusMsg && (
                <VuiTypography
                  mt={2}
                  color={statusMsg.includes("sucesso") ? "success" : "error"}
                  textAlign="center"
                >
                  {statusMsg}
                </VuiTypography>
              )}
            </VuiBox>
          </CardContent>
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ContactPage;